import { Injectable } from '@angular/core';
import { firstValueFrom, map, Observable, retry, Subject } from 'rxjs';
import { EndpointsService } from './endpoints.service';
import { HttpService } from './http.service';
import { dataset, pageTitle, typeEvent } from '../enum/enum';
import { HttpHeaders } from '@angular/common/http';
import { format, parseISO } from 'date-fns';
import { Auth } from '@angular/fire/auth';
import { ProfileService } from './profile.service';
import { WalletService } from './wallet.service';
import { Util } from '../util/util';
import { ConfirmController } from '../controllers/confirm.controller';
import { IAddress } from '../models/address.interface';

@Injectable({
    providedIn: 'root',
})
export class SalesService {
    private paymentCard$: Subject<string> = new Subject<string>();
    private paymentCvv$: Subject<string> = new Subject<string>();
    

    sale?: any;

    constructor(
        private auth: Auth,
        private profileService: ProfileService,
        private walletService: WalletService,
        private httpService: HttpService,
        private endpoints: EndpointsService,
        private confirmController: ConfirmController,
        private util: Util
    ) {}

    getPaymentCard(): Observable<any> {
        return this.paymentCard$.asObservable();
    }

    setPaymentCard(card: string) {
        this.paymentCard$.next(card);
    }

    getPaymentCvv(): Observable<any> {
        return this.paymentCvv$.asObservable();
    }

    setPaymentCvv(cvv: string) {
        this.paymentCvv$.next(cvv);
    }

    fetchCardMit(amount: any, userId: any): Observable<any> {
        const body: any = {
            amount: amount,
            userId: userId,
        };

        return this.httpService.post(this.endpoints.salesMitCard, body);
    }

    fetchReferenceMit(referenceId: string): Observable<any> {
        return this.httpService
            .get(
                this.endpoints.salesMitReference.replace(
                    '{referenceId}',
                    referenceId
                )
            )
            .pipe(
                map((val: any) => {
                    if (val.data == null) throw new Error('Invalid Value');
                    return val;
                }),
                retry({ count: 60, delay: 5000 })
            );
    }

    fetchCardPraga(
        amount: any,
        userId: any,
        businessPragaId: any
    ): Observable<any> {
        let date = new Date();
        let day = `${date.getDate()}`.padStart(2, '0');
        let month = `${date.getMonth() + 1}`.padStart(2, '0');
        let year = date.getFullYear();

        let finalDate = `${day}/${month}/${year}`;

        const body: any = {
            ammount: amount,
            businessId: businessPragaId,
            effectiveDate: finalDate,
            station: 'APP',
            saveWithClientId: userId,
            requestEmail: true,

        };

        return this.httpService.post(this.endpoints.salesPragaCard, body);
    }

    async registerSale(
        email: string,
        phoneClient: string,
        phoneBusiness: string,
        servicesProducts: any,
        hasDelivery: number,
        deliveryPrice: number,
        address: IAddress,
        total: number,
        subtotal:number,
        ownerId: string,
        appointmentId: number,
        businessId: string,
        productList: any,
        servicesProdDisc: any,
        comments: any,
        appointmentList: any[]
    ) {
        let date = new Date().toISOString();
        let today = format(parseISO(date), 'yyyy-MM-dd');
        let hourToday = format(parseISO(date), 'HH:mm');
        let sale_date = today + ' ' + hourToday;

        let nameUser =
            this.profileService.userProfile.name +
            ' ' +
            this.profileService.userProfile.first_family_name;

        if (this.walletService.cardSelectedEco) {
            this.sale = {
                customerName: nameUser,
                mail: email,
                phoneClient: phoneClient,
                phoneBusiness: phoneBusiness,
                isUserRegistered: true,
                total: total,
                salesDateTime: sale_date,
                servicesProducts: servicesProducts,
                appointmentId: appointmentId,
                subtotal: subtotal,
                taxes: 0.0,
                discount: 0.0,
                discountCode: 0.0,
                payment: {
                    userId: this.walletService.cardSelectedEco.record.userId,
                    isTarjetaVirtual: true,
                },
                cardId: this.walletService.cardSelectedEco.key,
                discounts: { discounts: servicesProdDisc },
                comments: comments,
                hasDelivery: hasDelivery,
                deliveryPrice: deliveryPrice,
                address: address,
                appointmentList: { appointmentList: appointmentList },
            };
        } else {
            this.sale = {
                customerName: nameUser,
                mail: email,
                phoneClient: phoneClient,
                phoneBusiness: phoneBusiness,
                isUserRegistered: true,
                total: total,
                salesDateTime: sale_date,
                servicesProducts: servicesProducts,
                appointmentId: appointmentId,
                subtotal: subtotal,
                taxes: 0.0,
                discount: 0.0,
                discountCode: 0.0,
                payment: {
                    userId: this.auth.currentUser!.uid,
                    isTarjetaVirtual: false,
                },
                reference: this.walletService.referenceCardEco,
                cardId: null,
                discounts: { discounts: servicesProdDisc },
                comments: comments,
                hasDelivery: hasDelivery,
                deliveryPrice: deliveryPrice,
                address: address,
                appointmentList: { appointmentList: appointmentList },
            };
        }

        let headers = new HttpHeaders({
            userId: this.auth.currentUser!.uid,
            businessId: businessId,
            receiveNotifications: 'true',
        });

        this.util.eventSalesTagAnalytics(
            this.sale,
            productList,
            pageTitle.shoppingCart,
            typeEvent.pagoApp,
            dataset.sales
        );

        const response: any = await firstValueFrom(
            this.httpService.post(
                this.endpoints.sales
                    .replace('{ownerId}', ownerId)
                    .replace('{businessId}', businessId),
                this.sale,
                { headers: headers }
            )
        );

        if (response && response.success) {
            if (response.success) {
                this.walletService.cardSelectedEco = [];
                this.walletService.cardSelectedEco = '';
                return response.data;
            } else {
                await this.confirmController.createAndPresent({
                    message: response.message,
                });
            }
        } else {
            await this.confirmController.createAndPresent({
                message: 'No se pudo realizar la compra, intente nuevamente',
            });
        }
    }
}
